import React from "react";
import { useTranslation } from "react-i18next";
import { hrefFor } from "../lib/router";
import { ForgeMark, MoonIcon, SunIcon } from "./Icons";

function AppHeader({ theme, onToggleTheme, crumbs = [], rankChip, children }) {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage || "en";

  return (
    <header className="app-header">
      {/* A plain href="#main" would be read as a route by the hash router, so focus the content directly. */}
      <a
        className="skip-link"
        href="#main"
        onClick={(event) => {
          event.preventDefault();
          const main = document.getElementById("main");
          main?.setAttribute("tabindex", "-1");
          main?.focus();
        }}
      >
        {t("app.skipToContent")}
      </a>
      <div className="app-header__left">
        {children}
        <a className="brand" href={hrefFor(null)}>
          <ForgeMark />
          <span className="brand__name">Code Forge</span>
        </a>
        {crumbs.length > 0 && (
          <nav className="crumbs" aria-label="Breadcrumb">
            {crumbs.map((crumb, index) => (
              <React.Fragment key={crumb.label}>
                <span className="crumbs__sep" aria-hidden="true">/</span>
                {crumb.href && index < crumbs.length - 1 ? (
                  <a href={crumb.href}>{crumb.label}</a>
                ) : (
                  <span aria-current={index === crumbs.length - 1 ? "page" : undefined}>{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
      </div>
      <div className="app-header__right">
        {rankChip}
        <div className="segmented" role="group" aria-label={t("app.language")}>
          {["en", "pt"].map((lng) => (
            <button
              key={lng}
              type="button"
              className={language === lng ? "is-active" : ""}
              aria-pressed={language === lng}
              onClick={() => i18n.changeLanguage(lng)}
            >
              {lng.toUpperCase()}
            </button>
          ))}
        </div>
        <button
          type="button"
          className="icon-button"
          onClick={onToggleTheme}
          aria-label={theme === "dark" ? t("app.themeLight") : t("app.themeDark")}
          title={theme === "dark" ? t("app.themeLight") : t("app.themeDark")}
        >
          {theme === "dark" ? <SunIcon /> : <MoonIcon />}
        </button>
      </div>
    </header>
  );
}

export default AppHeader;
